"use strict";
export default ['service', (service) => {
    class CustomerAutocompleteDirective {
        restrict = 'A';
        require = 'ngModel';
        scope = {
            searchString: '=ngModel',
            properties: '=customerautocomplete',
            context: '='
        };


        link(scope, element, attr, model) {
            var properties = {
                labelField: 'label'
            };
            if (scope.properties) {
                _.extend(properties, scope.properties);
            }

            element.autocomplete({
                minLength: properties.searchOnFocus ? 0 : properties.minLength || 2,
                position: {
                    my: "left top+10",
                    at: "left bottom",
                    collision: "flip"
                },
                source: function (request, response) {
                    let params = {value: request.term};

                    if (!!properties.paramsCallback)
                        properties.paramsCallback(params);

                    service.apiPost(properties.url, params)
                        .then(
                            (data)=> {
                                if (properties.emptyResultCallback && properties.isResultEmpty(request.term, data.value)) {
                                    properties.emptyResultCallback();
                                }
                                let result = [];
                                angular.forEach(data.value, function (item) {
                                    let listItem = {
                                        label: typeof item === 'object' ? item[properties.labelField] : item,
                                        object: item
                                    };

                                    if (!!properties.valueField)
                                        listItem.value = item[properties.valueField];

                                    result.push(listItem);
                                });
                                response(result);
                            },
                            (result)=> {
                                if (properties.errorCallback)
                                    properties.errorCallback(result);
                            }
                        )
                },
                select: (event, ui)=> {
                    model.$setViewValue(ui.item.label);

                    if (properties.selectCallback)
                        properties.selectCallback(ui.item.object, scope.context);

                    scope.$apply();
                },
                response: (event, ui)=> {
                    if (properties.responseCallback)
                        properties.responseCallback(ui.content, scope.context);
                }
            })

             .data("ui-autocomplete")._renderItem = function(ul, item) {
                return $("<li>")
                    .append("<a>" + item.label + "<span class='meta'>" + item.object.code + "</span></a>")
                    .appendTo(ul);
            };


            if (properties.searchOnFocus) {
                element.click(function () {
                    $(this).autocomplete('search', $(this).val())
                });
            }
            
            
        }
    }

    return new CustomerAutocompleteDirective();
}];



// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/customer-autocomplete.directive.js